
import BiPaiSeatCards from "./bipai_seat_cards";
import BiPaiCardTypeAnimHolder from "./bipai_cardtype_anim_holder";
import ComponentHolder from "../../../public/ui/componentHolder";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu("custom/bipai/BiPaiSeatCards")
export default class BiPaiSeatMingCards extends BiPaiSeatCards{
    @property(cc.Node)
    nodeResultTag: cc.Node = null

    @property(cc.Node)
    nodeResultWin: cc.Node = null

    @property(cc.Node)
    nodeResultLose: cc.Node = null

    @property(cc.Node)
    nodeResultWinAnim: cc.Node = null

    @property(cc.Label)
    labelLoseResult: cc.Label = null

    @property(cc.Label)
    labelWinResult: cc.Label = null

    @property(cc.Label)
    labelWinAnimResult: cc.Label = null


    @property(cc.Node)
    nodeWinAnimParent: cc.Node = null

    @property(cc.Node)
    nodeWinAnimPrefab: cc.Node = null

    @property(cc.Node)
    nodeOpenCardAnimParent: cc.Node = null

    @property(cc.Node)
    nodeOpenCardAnimPrefab: cc.Node = null

    @property(BiPaiCardTypeAnimHolder)
    cardTypeAnimHolder: BiPaiCardTypeAnimHolder = null

    @property(cc.Node)
    nodeKaiPaiLoseAnim: cc.Node = null

    @property(cc.Node)
    nodeScoreWinAnim: cc.Node = null

    @property(cc.Label)
    labelWinScore: cc.Label = null

    @property(cc.Node)
    nodeScoreLoseAnim: cc.Node = null

    @property(cc.Label)
    labelLoseScore: cc.Label = null

    @property(cc.Node)
    nodeTurnAnimParent: cc.Node = null

    @property(ComponentHolder)
    comHolderTurnAnimPrefab: ComponentHolder = null

    @property(cc.Float)
    adjustDuration: number = 1

    @property(cc.Float)
    tagAnimDuration: number = 1

    @property(cc.Float)
    tagAnimDelay: number = 0

    @property(cc.Boolean)
    fromEnd: boolean = false

    @property(cc.Node)
    nodeJiePaoAnim: cc.Node = null

    @property(cc.Node)
    nodeJiePaoAnimParent: cc.Node = null

    protected m_nodeJiePaoAnim: cc.Node = null

    protected m_comHolderTurnAnim: ComponentHolder = null
    protected m_nodeWinAnim: cc.Node = null

    protected ensureInitedNode(node: cc.Node, prefab: cc.Node, parent: cc.Node): cc.Node{
        let newNode = node || cc.instantiate(prefab)
        newNode.parent = parent
        newNode.position = cc.Vec2.ZERO
        return newNode
     }


    playJiePaoAnim(show: boolean, onFinish?: Function){
        let self = this
        self.m_nodeJiePaoAnim = self.ensureInitedNode(self.m_nodeJiePaoAnim, self.nodeJiePaoAnim, self.nodeJiePaoAnimParent)
        self.m_nodeJiePaoAnim.active = !!show
        self.scheduleOnce(function(){
            self.m_nodeJiePaoAnim.active = false
            onFinish && onFinish()
        }, 1.67)
              
    }

    showResult(show: boolean, num?: number, isGray?: boolean){
        this.labelWinResult.string = num + ''
        this.labelLoseResult.string = num + ''
        this.nodeResultWin.active = show && !isGray
        this.nodeResultLose.active = show && !!isGray
    }

    protected playTurnAnim(code: number, onFinish?: Function){
        let self = this
        this.ensureTurnAnim()
        let poker = self.genPoker(code)
        poker.show()
        poker.node.parent = self.m_comHolderTurnAnim.getNodeByKey('turnPokerParent')
        poker.node.position = cc.Vec2.ZERO

        let pokerBack = self.genPoker(code)
        pokerBack.showBack(true)
        pokerBack.showFace(false)
        pokerBack.show()
        pokerBack.node.parent = self.m_comHolderTurnAnim.getNodeByKey('pokerBackParent')
        pokerBack.node.position = cc.Vec2.ZERO
        
        self.m_comHolderTurnAnim.node.active = true        
        self.scheduleOnce(function(){
            self.m_comHolderTurnAnim.node.active = false
            poker.hide()
            pokerBack.hide()

            let lastFun = self.getNodeActionCallback(poker.node)
            if(lastFun){
                self.setNodeActionCallback(poker.node, null)
                lastFun()
            }        
            
            poker.node.stopAllActions()
            pokerBack.node.stopAllActions()
            self.recyclePoker(poker)
            self.recyclePoker(pokerBack)
            onFinish && onFinish()
        }, 0.55)
    }

    protected ensureTurnAnim(){
        if(this.m_comHolderTurnAnim){
            return
        }
        let node = cc.instantiate(this.comHolderTurnAnimPrefab.node)
        node.parent = this.nodeTurnAnimParent
        node.position = cc.Vec2.ZERO
        node.scale = 1
        this.m_comHolderTurnAnim = node.getComponent(ComponentHolder)
    }
    
    showPokers(show: boolean, codeList?: number[], params?: any){
        let self = this
        let baseShowPokers = super.showPokers.bind(self)
        let result = super.showPokers(show, codeList, params)
        self.showResult(false)
        if(show && params && params.playAnim){            
            let pokers = self.pokers
            if(pokers.length == 0){
                params.onFinishPlayAnim && params.onFinishPlayAnim()
                return
            }
            let firstPos
            let firstWorldPos
            let nodeList = []
            for (let index = 0; index < pokers.length; index++) {
                const poker = pokers[index];
                poker.hide()
                if((self.fromEnd && index == pokers.length - 1) || (!self.fromEnd && index == 0)){
                    firstPos = poker.original_pos
                    firstWorldPos = poker.node.parent.convertToWorldSpaceAR(poker.original_pos)
                }
                nodeList.push(poker.node)
            }    
            self.nodePokersParent.active = false        
            self.playTurnAnim(codeList[codeList.length - 1], function(){
                for (let index = 0; index < pokers.length; index++) {
                    const poker = pokers[index];
                    poker.show()  
                    poker.node.position = firstPos                  
                }  
                self.nodePokersParent.active = true
                self.playAdjustAnim(nodeList, nodeList.length, self.adjustDuration, 0, function(){
                    baseShowPokers(show, codeList, params)
                }, cc.easeBackOut())
                let tranData = self.getPosData(pokers.length, pokers.length)
                self.showResult(!params.hidePointNum, params.pointNum, params.isGray || false)
                let node = self.nodeResultTag
                node.active = true
                node.position = node.parent.convertToNodeSpaceAR(firstWorldPos)
                let targetPos = node.parent.convertToNodeSpaceAR(tranData.worldPos)                
                self.playNodeAnim(node, targetPos, 1, 0, self.tagAnimDuration, self.tagAnimDelay, function(){
                    params.onFinishPlayAnim && params.onFinishPlayAnim()
                }, cc.easeBackOut())
            })            
        }else{

        }
        return result
    }

    showWinAnim(show: boolean, onFinish?: Function){
        if(!show && !this.m_nodeWinAnim){
            return
        }
        this.m_nodeWinAnim = this.ensureInitedNode(this.m_nodeWinAnim, this.nodeWinAnimPrefab, this.nodeWinAnimParent)
        let node = this.m_nodeWinAnim
        node.active = !!show
        if(show){
            this.scheduleOnce(function(){
                onFinish && onFinish()
            }, 0.5)
        }
    }
}
